import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import HighSchoolTranscriptStatusService from "../../src/Services/HighSchoolTranscriptStatus.service";
import LookupGeneric from "./lookupGeneric";
const HighSchoolTranscriptStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            return HighSchoolTranscriptStatusService.findByIds(ids);
        },
        fetchOptions: (query) => {
            return HighSchoolTranscriptStatusService.search({
                query,
                active: true, // if HighSchoolTranscriptStatus has an active field for this purpose
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(highSchoolTranscriptStatus) {
            return _jsx("span", { children: highSchoolTranscriptStatus.name });
        },
    });
};
export default HighSchoolTranscriptStatusLookup;
